import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-iframe-page',
  templateUrl: './iframe-page.component.html',
  styleUrls: ['./iframe-page.component.scss']
})
export class IframePageComponent implements OnInit {
  iframeUrl: string = '';
  pageTitle: string = '';

  constructor(
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.iframeUrl = data['iframeUrl'] || '';
      this.pageTitle = data['pageTitle'] || 'Sayfa';
    });

    this.document.title = this.pageTitle;
  }
} 